import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./theme";
import App from "./App";
import About from "./pages/About";
import Services from "./pages/Services";
import MonthlyBookkeeping from "./pages/monthly-bookkeeping";
import TaxpreParation from "./pages/tax-preparation";
import FinancialPlanning from "./pages/financial-planning";
import BusinessConsulting from "./pages/business-consulting";
import Contact from "./pages/Contact";
import Seo from "./components/Seo";
import PageTransition from "./components/PageTransition";
import { TranslationProvider } from "./translations/TranslationContext";

// Create a wrapper component to use the location hook
const AnimatedRoutes = () => {
  const location = useLocation();
  
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route index element={
          <PageTransition>
            <App />
          </PageTransition>
        } />
        <Route path="/about" element={
          <PageTransition>
            <About />
          </PageTransition>
        } />
        <Route path="/services" element={
          <PageTransition>
            <Services />
          </PageTransition>
        } />
        <Route path="/monthly-bookkeeping" element={
          <PageTransition>
            <MonthlyBookkeeping />
          </PageTransition>
        } />
        <Route path="/tax-preparation" element={
          <PageTransition>
            <TaxpreParation />
          </PageTransition>
        } />
        <Route path="/financial-planning" element={
          <PageTransition>
            <FinancialPlanning />
          </PageTransition>
        } />
        <Route path="/business-consulting" element={
          <PageTransition>
            <BusinessConsulting />
          </PageTransition>
        } />
        <Route path="/contact" element={
          <PageTransition>
            <Contact />
          </PageTransition>
        } />
      </Routes>
    </AnimatePresence>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <TranslationProvider>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Seo />
        <AnimatedRoutes />
      </Router>
    </ThemeProvider>
  </TranslationProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//  reportWebVitals();
